"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.TabNavigator = exports.TabNavigationItems = exports.TabNavigationItem = void 0;
const TabNavigation_1 = require("./TabNavigation");
Object.defineProperty(exports, "TabNavigationItem", { enumerable: true, get: function () { return TabNavigation_1.TabNavigationItem; } });
Object.defineProperty(exports, "TabNavigationItems", { enumerable: true, get: function () { return TabNavigation_1.TabNavigationItems; } });
const react_1 = __importStar(require("react"));
const kebabCase_1 = __importDefault(require("lodash/kebabCase"));
const useQuery_1 = require("./hooks/useQuery");
exports.TabNavigator = (0, react_1.memo)((props) => {
    const { tabHeader, slim = false, horizontal = false, paddingBottom = false, controls, noPadding, 'data-testid': testId, } = props;
    const { activeChild, activeLabelIndex, tabs } = useTabNavigator(props);
    return (react_1.default.createElement(TabNavigation_1.TabNavigationContainer, { slim: slim && !horizontal, horizontal: horizontal, noPadding: noPadding, paddingBottom: paddingBottom },
        react_1.default.createElement(TabNavigation_1.TabNavigationItems, { testId: testId, controls: controls },
            tabHeader,
            tabs.map(({ label, testId, activateTab }, i) => {
                return (react_1.default.createElement(TabNavigation_1.TabNavigationItem, { key: i, active: i === activeLabelIndex, testId: testId || `${(0, kebabCase_1.default)(String(label))}-tab`, onClick: () => {
                        activateTab();
                    } }, typeof label === 'function'
                    ? label({
                        activateTab,
                    })
                    : label));
            })),
        activeChild));
});
/**
 * Generalized hook that can be used to skin other tab components.
 *
 * TODO: possibly consider hooking this up to HTTP location
 */
const useTabNavigator = ({ children, id }) => {
    const [internalLabelIndex, setInternalLabelIndex] = (0, react_1.useState)(0);
    const elementChildren = react_1.default.Children.map(children, (child) => react_1.default.isValidElement(child) ? child : null).filter(Boolean);
    const [query, updateQuery] = (0, useQuery_1.useQuery)();
    const activeLabelIndex = id && query[id] != null ? Number(query[id]) : internalLabelIndex;
    const onTabActivate = (index, query = {}) => {
        if (id) {
            updateQuery(Object.assign(Object.assign({}, query), { [id]: index }));
        }
        else {
            setInternalLabelIndex(index);
        }
    };
    const tabs = elementChildren.map((child, index) => {
        return {
            label: child.props.label,
            testId: child.props['data-testid'],
            activateTab: (query = {}) => {
                onTabActivate(index, query);
            },
        };
    });
    return {
        activeChild: elementChildren[activeLabelIndex],
        tabs,
        activeLabelIndex,
    };
};
const Tab = ({ children }) => {
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.Tab = Tab;
//# sourceMappingURL=TabNavigator.js.map